// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck - we dynamically create the other index files, so these will throw errors if we don't ignore them

import { browserExt } from './environment-browser/browserExt';
import { webworkerExt } from './environment-webworker/webworkerExt';
import { extensions } from './extensions/Extensions';
import './rendering/init';
import './spritesheet/init';

export * from './accessibility';
export * from './advanced-blend-modes';
export * from './app';
export * from './assets';
export * from './color';
export * from './compressed-textures';
export * from './culling';
export * from './environment';
export * from './environment-browser';
export * from './environment-webworker';
export * from './events';
export * from './extensions';
export * from './filters';
export * from './maths';
export * from './prepare';
export * from './rendering';
export * from './scene';
export * from './spritesheet';
export * from './ticker';
export * from './utils';

extensions.add(browserExt, webworkerExt);
